<template>
<Loader :loading="loading" v-if="loading" />

<div v-else>
    <app-bar></app-bar>
    <Home></Home>
    <Footer></Footer>
</div>
</template>

<script>
import appBar from './appBar.vue'
import Footer from './Footer.vue';
import Home from './Home.vue';
import Loader from '@/components/Loader/Loader.vue';
// import loaderSet from '@/mixins/loaderSet';
export default {
	// mixins:[loaderSet],
    components: {
        appBar,
        Home,
        Loader,
        Footer
    },

}
</script>

<style>
/* Get in Touch button */
.btn-design {
    background: linear-gradient(135deg, #06923e, #b87c4c) !important;
    color: #fff !important;
    font-weight: 600;
    padding: 0 24px;
    height: 44px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.btn-design:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.section-title {
    font-size: 2.3rem;
    font-weight: 900;
    margin-bottom: 1rem;
    background: linear-gradient(15deg, #2e7d32, #43a047 60%, #b87c4c 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* .section-underline {
  width: 120px;
  height: 4px;
  background-color: #b87c4c;
  margin: 0.5rem auto 1.5rem;
  border-radius: 2px;
} */

.section-subtitle {
    font-size: 1.1rem;
    color: #555;
    max-width: 700px;
    margin: 0 auto;
    line-height: 1.6;
    font-style: italic;
}

.hero-title {
    font-size: 2.5rem;
    font-weight: 900;
    margin-bottom: 1rem;
    background: linear-gradient(135deg, #ffffff, #b87c4c);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
